// Customer Story — centred pull-quote (Figma 4954:15373).
// Display-size quote whose trailing clause is muted (grey-400), with the
// attribution split between grey-950 (name) and grey-500 (role).

import { splitQuoteTone } from "@/lib/content/customer-story-quote-tone";

interface CustomerStoryQuoteProps {
  /** Leading, full-emphasis portion of the quote (no surrounding marks). */
  text: string;
  /** Trailing, muted portion of the quote. Inferred from `text` when omitted. */
  highlight?: string;
  authorName: string;
  authorRole: string;
}

export function CustomerStoryQuote({
  text,
  highlight,
  authorName,
  authorRole,
}: CustomerStoryQuoteProps) {
  const tone = highlight ? { text, highlight } : splitQuoteTone(text);

  return (
    <section className="bg-grey-50 border-grey-100 flex flex-col items-center border-t px-8 py-12 text-center lg:border-t-0 lg:px-20 lg:py-20">
      <figure className="flex w-full max-w-[267px] flex-col items-center gap-6 lg:max-w-[774px] lg:gap-8">
        <blockquote className="text-ds-heading-h3 text-grey-950 lg:text-ds-display-md text-balance">
          {"“"}
          {tone.text}
          {tone.highlight ? (
            <span className="text-grey-400">
              {" "}
              {tone.highlight}
              {"”"}
            </span>
          ) : (
            "”"
          )}
        </blockquote>
        <figcaption className="text-ds-body-lg text-grey-950 leading-[1.3]">
          <span className="block lg:inline">{authorName}, </span>
          <span className="text-grey-500 block lg:inline">{authorRole}</span>
        </figcaption>
      </figure>
    </section>
  );
}
